import * as userActions from './users/user.actions';
export default {
  ...userActions,
};
